import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  sendRequest as resendConfirmToken,
  selectRequestState
} from 'mt-react-common/modules/users/common/reducers/forms/resendConfirmTokenAction';
import OpacityPreLoader from '../../../../Common/PreLoaders/OpacityPreLoader';
import CancelEmailChangeRequestLink from '../_common/CancelEmailChangeRequestLink';

const resendChangeEmailConfirmTokenActionRN =
  'usersModule.forms.resendChangeEmailConfirmTokenAction';

class ChangeEmailConfirmNoticeBlock extends Component {
  state = {
    hasLoading: false
  };

  handleResendConfirmToken = e => {
    e.preventDefault();
    this.props.resendConfirmToken();
  };

  render() {
    return (
      <div>
        <article className="panel panel-success">
          <div className="panel-heading text-center">
            <h3 className="panel-title">Подтверждение смены адреса почты</h3>
          </div>
          <div className="panel-body">
            {this.props.requestState.hasInProgress || this.state.hasLoading ? (
              <OpacityPreLoader />
            ) : null}
            <p>
              Есть не подтвержденный запрос изменения email адреса на{' '}
              {this.props.authAccountData.newEmail}, дальнейшие инструкции
              отправлены на {this.props.authAccountData.email}
            </p>
            <p>
              Если письма нет, проверьте папочку спам или сделайте{' '}
              <a href="" onClick={this.handleResendConfirmToken}>
                повторный запрос
              </a>
              .<br />
            </p>
            <p className="m-b-0">
              <CancelEmailChangeRequestLink
                authAccountData={this.props.authAccountData}
                setLoading={bool => {
                  this.setState({
                    hasLoading: bool
                  });
                }}
              />
            </p>
          </div>
        </article>
      </div>
    );
  }
}

ChangeEmailConfirmNoticeBlock.propTypes = {
  // IN
  authAccountData: PropTypes.shape({
    email: PropTypes.string.isRequired,
    newEmail: PropTypes.string.isRequired,
    emailConfirm: PropTypes.number.isRequired
  }).isRequired,

  // CONNECT
  resendConfirmToken: PropTypes.func.isRequired,
  requestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired,
    hasSuccessQuery: PropTypes.bool
  }).isRequired
};

const mapStateToProps = state => ({
  requestState: selectRequestState(state, resendChangeEmailConfirmTokenActionRN)
});

const mapDispatchToProps = dispatch => ({
  resendConfirmToken: () =>
    dispatch(resendConfirmToken(resendChangeEmailConfirmTokenActionRN))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangeEmailConfirmNoticeBlock);



// WEBPACK FOOTER //
// ./src/components/UserAccount/Confirms/ConfirmNoticeBlocks/ChangeEmailConfirmNoticeBlock/ChangeEmailConfirmNoticeBlock.js